import type React from "react";
import {Typography} from "@mui/material";
import {updatedMonth} from "./pdlFormat";

/** "Updated Sep 2026" under a company/workforce block, from the snapshot's own retrieved_at. */
export const SnapshotMeta: React.FC<{retrievedAt: string | null | undefined}> = ({retrievedAt}) => {
    const month = updatedMonth(retrievedAt);
    if (!month) return null;
    return <Typography variant="caption" color="text.secondary" sx={{width: 'fit-content'}}>{`Updated ${month}`}</Typography>;
};
